import {
    UPDATE_AUTH_NAMES_LIST,
    AUTHORIZE_ACTIVE_JOB_REQUEST,
    AUTHORIZE_ACTIVE_JOB_SUCCESS,
    AUTHORIZE_ACTIVE_JOB_NONE,
    AUTHORIZE_ACTIVE_JOB_ERROR,
    AUTHORIZE_START_JOB_REQUEST,
    AUTHORIZE_START_JOB_SUCCESS,
    AUTHORIZE_START_JOB_CONFLICT,
    AUTHORIZE_START_JOB_ERROR,
    AUTHORIZE_POLL_JOB_TICK,
    AUTHORIZE_POLL_JOB_RETRY,
    AUTHORIZE_POLL_JOB_ERROR,
    AUTHORIZE_JOB_TERMINAL,
    AUTHORIZE_CLEAR_JOB_RESULT
} from './types'

const initialState = {
    names: [],
    reduxTableData: [],
    formData: {},
    runningJob: null,
    lastJobResult: null,
    jobStarting: false,
    activeJobLoading: false,
    jobError: null,
    pollingError: null,
    pollingRetryCount: 0
};

const clearTableSelection = (rows) => Array.isArray(rows)
    ? rows.map((row) => ({ ...row, select: false, operation: '' }))
    : [];

const authNamesReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case UPDATE_AUTH_NAMES_LIST:
            return {
                ...state,
                ...payload
            }
        case AUTHORIZE_ACTIVE_JOB_REQUEST:
            return { ...state, activeJobLoading: true, jobError: null };
        case AUTHORIZE_ACTIVE_JOB_SUCCESS:
            return {
                ...state,
                activeJobLoading: false,
                runningJob: payload,
                pollingError: null,
                pollingRetryCount: 0
            };
        case AUTHORIZE_ACTIVE_JOB_NONE:
            return { ...state, activeJobLoading: false, runningJob: null };
        case AUTHORIZE_ACTIVE_JOB_ERROR:
            return { ...state, activeJobLoading: false, jobError: payload };
        case AUTHORIZE_START_JOB_REQUEST:
            return { ...state, jobStarting: true, jobError: null, pollingError: null };
        case AUTHORIZE_START_JOB_SUCCESS:
            return {
                ...state,
                names: [],
                reduxTableData: clearTableSelection(state.reduxTableData),
                runningJob: payload,
                lastJobResult: null,
                jobStarting: false,
                pollingError: null,
                pollingRetryCount: 0
            };
        case AUTHORIZE_START_JOB_CONFLICT:
            return {
                ...state,
                runningJob: payload,
                lastJobResult: null,
                jobStarting: false,
                pollingError: null,
                pollingRetryCount: 0
            };
        case AUTHORIZE_START_JOB_ERROR:
            return { ...state, jobStarting: false, jobError: payload };
        case AUTHORIZE_POLL_JOB_TICK:
            return {
                ...state,
                runningJob: payload,
                pollingError: null,
                pollingRetryCount: 0
            };
        case AUTHORIZE_POLL_JOB_RETRY:
            return {
                ...state,
                pollingError: payload.message,
                pollingRetryCount: payload.attempt
            };
        case AUTHORIZE_POLL_JOB_ERROR:
            return { ...state, pollingError: payload, pollingRetryCount: 0 };
        case AUTHORIZE_JOB_TERMINAL:
            return {
                ...state,
                names: [],
                reduxTableData: clearTableSelection(state.reduxTableData),
                runningJob: null,
                lastJobResult: payload,
                jobStarting: false,
                pollingError: null,
                pollingRetryCount: 0
            };
        case AUTHORIZE_CLEAR_JOB_RESULT:
            return { ...state, lastJobResult: null, jobError: null, pollingError: null };
           
        default:
            return state;
    }
};

export default authNamesReducer;
